import { EWindowsType } from '../../../../api-models/common/json_query';

export const WINDOWS_TYPE_MAP_VALUE_TO_LABEL = {
  [EWindowsType.Courtyard]: 'во двор',
  [EWindowsType.Street]: 'на улицу',
};
